// extracted by mini-css-extract-plugin
export default {"powerbi-report-style-class":"reports_powerbi-report-style-class__IqlAH","report-style-class":"reports_report-style-class__UjXWj"};